import { RouteItem } from '@eastcoal/router/types/route'

export const passwordRoute: RouteItem = {
  title: '重置密码',
  path: '/password/reset',
  hideInMenu: true,
  Component: () => import('@eastcoal/auth/components/PasswordResetForm')
}
